import React, { useState } from 'react';

// components
import HookModalForm from '../../../components/HookModalForm/HookModalForm';
import EmptyData from '../../../components/EmptyData/EmptyData';
import Datepicker from '../../../components/Inputs/Datepicker/Datepicker';
import SelectClients from '../../../components/Selects/SelectClients';
import SelectDealStatuses from '../../../components/Selects/SelectDealStatuses';
import SelectDealPaymentTypes from '../../../components/Selects/SelectDealPaymentTypes';
import SelectDealPaymentStatuses from '../../../components/Selects/selectDealPaymentStatuses';
import SelectCars from '../../../components/Selects/SelectCars';
import SelectEquipments from '../../../components/Selects/SelectEquipments';
import SelectServices from '../../../components/Selects/SelectServices';
import DeleteButton from '../../../components/DeleteButton/DeleteButton';

// icons
import icon from '../../../brand/generated/buttonIcons/addDeal.svg';

const formStyles = {
  dealInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a m m' 'b b b b' 'c c c c'` },
  autoForm: { display: 'grid', columnGap: '20px', gridTemplateColumns: `auto 44px 0px` },
};

const NewClientsDeal = () => {
  const [showModal, setShowModal] = useState(false);

  const [dealInfo, setDealInfo] = useState([
    { name: 'createdAt', type: 'date', value: new Date(), label: 'ÐÐ°ÑÐ°', component: Datepicker, disabled: true },
    { name: 'id', type: 'input', label: 'ID', value: '35567809', disabled: true },
    {
      name: 'userId',
      component: SelectClients,
      label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      style: { gridArea: 'm' },
    },
    { name: 'statusId', component: SelectDealStatuses, label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
    {
      name: 'paymentTypeId',
      component: SelectDealPaymentTypes,
      label: 'Ð¤Ð¾ÑÐ¼Ð° Ð¾Ð¿Ð»Ð°ÑÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    },
    {
      name: 'statusPaymentId',
      component: SelectDealPaymentStatuses,
      label: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
    },
    { name: 'sum', type: 'input', label: 'Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸, KZT', placeholder: 'ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ°ÑÑÐµÑ', disabled: true },
    {
      name: 'comment',
      type: 'input',
      label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ',
      placeholder: 'ÐÐ°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
      style: { gridArea: 'c' },
    },
  ]);

  const [autoForm, setAutoForm] = useState({
    style: formStyles.autoForm,
    form: [],
    add: [
      { name: 'cars', component: SelectCars, label: 'ÐÐ²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' },
      {
        name: 'deleteCars',
        component: DeleteButton,
        onClick: () => {
          autoForm.form.length = 0;
          setAutoForm(autoForm);
          setActions((prev) => [...prev, (prev[0].show = true)]);
        },
      },
    ],
  });

  const [equipmentForm, setEquipmentForm] = useState({
    style: formStyles.autoForm,
    form: [],
    add: [
      {
        name: 'equipments',
        component: SelectEquipments,
        label: 'ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
        placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
        isMulti: true,
        isSearchable: true,
      },
      {
        name: 'deleteEquipments',
        component: DeleteButton,
        onClick: () => {
          equipmentForm.form.length = 0;
          setEquipmentForm(equipmentForm);
          setActions((prev) => [...prev, (prev[1].show = true)]);
        },
      },
    ],
  });

  const [serviceForm, setServiceForm] = useState({
    style: formStyles.autoForm,
    form: [],
    add: [
      {
        name: 'services',
        component: SelectServices,
        label: 'Ð£ÑÐ»ÑÐ³Ð¸',
        placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
        isMulti: true,
        isSearchable: true,
      },
      {
        name: 'deleteServices',
        component: DeleteButton,
        onClick: () => {
          serviceForm.form.length = 0;
          setServiceForm(serviceForm);
          setActions((prev) => [...prev, (prev[2].show = true)]);
        },
      },
    ],
  });

  const [documentForm, setDocumentForm] = useState({
    style: formStyles.autoForm,
    form: [],
    add: [{ type: 'select', value: '', label: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ', placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°' }, { type: 'delete' }],
  });

  const [actions, setActions] = useState([
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°Ð²ÑÐ¾Ð¼Ð¾Ð±Ð¸Ð»Ñ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð°ÐºÑÐµÑÑÑÐ°ÑÑ' },
    { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½ÑÑ ÑÑÐ»ÑÐ³Ñ' },
    // { show: true, text: 'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ Ðº ÑÐ´ÐµÐ»ÐºÐµ' },
  ]);

  const createDeal = (data) => {
    console.log(data);
  };

  return (
    <>
      <EmptyData
        title={'Ð¡Ð´ÐµÐ»ÐºÐ¸ (0)'}
        subtitle={'Ð­ÑÐ¾Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð¿Ð¾ÐºÐ° Ð½Ðµ ÑÑÐ°ÑÑÐ²ÑÐµÑ Ð½Ð¸ Ð² Ð¾Ð´Ð½Ð¾Ð¹ ÑÐ´ÐµÐ»ÐºÐµ'}
        action="ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ Ð½Ð¾Ð²ÑÑ ÑÐ´ÐµÐ»ÐºÑ"
        icon={icon}
        showModal={() => setShowModal(true)}
      />
      {showModal && (
        <HookModalForm
          title={'ÐÐ¾Ð²Ð°Ñ ÑÐ´ÐµÐ»ÐºÐ° Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ¾Ð¼'}
          closeModal={() => setShowModal(false)}
          mainForm={dealInfo}
          setMainForm={setDealInfo}
          formTitle={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
          grid={formStyles.dealInfo}
          forms={[autoForm, equipmentForm, serviceForm, documentForm]}
          actions={actions}
          button={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ ÑÐ´ÐµÐ»ÐºÑ'}
          setActions={setActions}
          setForm={[setAutoForm, setEquipmentForm, setServiceForm, setDocumentForm]}
          handleSubmit={createDeal}
        />
      )}
    </>
  );
};

export default NewClientsDeal;
